import { z } from "zod";

export const publicTimelinePhaseSchema = z.object({
  id: z.string(),
  revision: z.number(),
  state: z.enum(["pending", "ready", "failed", "superseded"]),
  category: z.string(),
  title: z.string(),
  body: z.string().nullable().optional(),
  activity_ids: z.array(z.string()).default([]),
  created_at: z.string().nullable().optional(),
  updated_at: z.string().nullable().optional(),
});

export const publicTimelineStepSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: z.enum(["running", "succeeded", "failed", "superseded"]),
  origin_run_id: z.string().nullable().optional(),
  started_seq: z.number().nullable().optional(),
  last_seq: z.number().nullable().optional(),
  started_at: z.string().nullable().optional(),
  finished_at: z.string().nullable().optional(),
});

export const publicTimelineResponseSchema = z.object({
  phases: z.array(publicTimelinePhaseSchema),
  steps: z.array(publicTimelineStepSchema),
  next_cursor: z.string().nullable().optional(),
  has_more: z.boolean(),
  pending_count: z.number(),
  started_at: z.string().nullable().optional(),
  completed_at: z.string().nullable().optional(),
});
